module.exports = __webpack_public_path__ + "img/02.6e7f8453.jpg";